import { useEffect } from "react";
import { Linking } from "react-native";
// import queryString from "query-string";

const parseDeepLink = (url: string) => {
    try {
        // const parsed = queryString.parseUrl(url);
        // const params: Record<string, any> = parsed.query;

        // Object.keys(params).forEach((key) => {
        //     if (typeof params[key] === "string" && !isNaN(parseFloat(params[key] as string))) {
        //         params[key] = parseFloat(params[key] as string);
        //     }
        // });

        // return params;
        return {};
    } catch (error) {
        console.error("Error parsing deep link:", error);
        return {};
    }
};

const useDeepLinking = (onDeepLink: (params: Record<string, any>) => void) => {
    useEffect(() => {
        const handleDeepLink = ({ url }: { url: string }) => {
            const parsedParams = parseDeepLink(url);
            console.log("Deep link detected:", parsedParams);
            onDeepLink(parsedParams);
        };

        // Subscribe to deep link events
        const subscription = Linking.addEventListener("url", handleDeepLink);

        // Handle deep link when the app is first opened
        Linking.getInitialURL().then((url) => {
            if (url) {
                handleDeepLink({ url });
            }
        });

        return () => {
            subscription?.remove();
        };
    }, [onDeepLink]);
};

export default useDeepLinking;
